import { Accessibility, AccessibilityRequest, AccessiblityQuery } from "../models/Accessibility";
import axios from "../utils/axios";
import { BasicQuerySearch, defaultQuery, generateQueryString, QueryResponse } from "./utilts";

export function fetchA11yes(a11yUnitId: string, token: any) {
    return new Promise<AccessiblityQuery>((resolve, reject) => {
        axios
          .get(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/?accessibility_unit__id=${a11yUnitId}&limit=999`, {
              headers: { Authorization: "Token " + token },
          })
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

export function fetchA11yesQuery(query: BasicQuerySearch & {
    limit?: number;
    accessibility_unit__id?: string;
    accessibility_unit__property__id?: string;
    accessibility_unit__property__company?: string;
} = {}, token: any) {
    return new Promise<AccessiblityQuery>((resolve, reject) => {
        axios
          .get(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/`, {
              headers: { Authorization: "Token " + token },
              params: query
          })
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}
export function fetchA11yesById(id: string, token: any) {
    return new Promise<AccessiblityQuery>((resolve, reject) => {
        axios
          .get(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/${id}`, {
              headers: { Authorization: "Token " + token },
          })
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

export function createA11y(data: AccessibilityRequest, token: any) {
    return new Promise<Accessibility>((resolve, reject) => {
        axios
          .post(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/`, data,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status === 201) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

export function deleteA11y(id: string, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
          .delete(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/${id}/`,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status === 204) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

export function updateA11y(id: string, data: AccessibilityRequest, token: string) {
    return new Promise<Accessibility>((resolve, reject) => {
        axios
          .put(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/${id}/`, data,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}
export function partialUpdateA11y(id: string, data: Partial<AccessibilityRequest>, token: string) {
    return new Promise<Accessibility>((resolve, reject) => {
        axios
          .patch(`${process.env.REACT_APP_API_DOMAIN}/accessibilities/${id}/`, data,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

export function fetchA11yExtraInfo(body: BasicQuerySearch & {
    accessibility_units__property__id?: string;
    accessibility_units__id?: string;
    accessibilities__id?: string;
    type?: string;
} = defaultQuery, token: string) {
    return new Promise<QueryResponse<any>>((resolve, reject) => {
        axios
          .get(`${process.env.REACT_APP_API_DOMAIN}/accessibility-extra-info/${generateQueryString(body)}`,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status === 200) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}

type AccessibilityExtraInfo = {
    accessibility_units?: string[],
    accessibilities?: string[]
    language_code: string;
    type?: string;
    extra_info: string
}
export function createA11yExtraInfo(body: AccessibilityExtraInfo, token: string) {
    return new Promise<AccessibilityExtraInfo>((resolve, reject) => {
        axios
          .post(`${process.env.REACT_APP_API_DOMAIN}/accessibility-extra-info/`, body,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status <= 400) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}
export function updateA11yExtraInfo(body: Partial<AccessibilityExtraInfo>, id: string, token: string) {
    return new Promise<AccessibilityExtraInfo>((resolve, reject) => {
        axios
          .patch(`${process.env.REACT_APP_API_DOMAIN}/accessibility-extra-info/${id}/`, body,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status <= 400) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}
export function deleteA11yExtraInfo(id: string, token: string) {
    return new Promise<AccessibilityExtraInfo>((resolve, reject) => {
        axios
          .delete(`${process.env.REACT_APP_API_DOMAIN}/accessibility-extra-info/${id}/`,
            { headers: { 'Authorization': 'Token ' + token } }
          )
          .then((response) => {
              if (response.status <= 400) {
                  resolve(response.data);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
    });
}
